<!-- Main Page Start -->
<div class="innerhomepage">
<section class="greybk">
  <div class="container">
    <div class="row item-align">
      <div class="col-lg-8 col-sm-12 col-md-12">
        <div class="whitebox flexcss leftSide">
          <div class="progressbar">
            <div style="max-width:200px; transform: rotate(-90deg);">
              <svg id="svg" height="100%" viewBox="0 0 20 20" width="100%" style="overflow: visible;">
                <circle cx="50%" cy="50%" fill="none" stroke-width="1" r="9" stroke="#f1f1f1"></circle>
                <circle cx="50%" cy="50%" fill="none" stroke-width="1" r="9"
                  [attr.stroke-dashoffset]="profileScore(dashboardData?.profileScore)" stroke-dasharray="56.5487"
                  [attr.stroke]="color(dashboardData?.profileScore)" stroke-linecap="round">
                </circle>
              </svg>
            </div>
            <div *ngIf="dashboardData?.profileScore" class="progressbartext">
              <h6 class="percentage">{{dashboardData?.profileScore}}%</h6>
              <p class="" [ngClass]="dashboardData?.profileScore > 50 ? 'quality' : 'text-orange'">{{dashboardData?.profileScore > 50 ? 'Good':'Poor'}}</p>
            </div>
          </div>
          <div class="profiledescription">
            <p>Welcome back {{userDetails?.name || ''}}</p>
            <h4>Your profile score</h4>
            <p class="para">Recruiters notice you from 70%</p>
            <a href="javascript:void(0);" class="allowBtn" *ngIf="dashboardData?.profileScore > 50"
              routerLink="/profile"> View Profile <img src="assets/images/arrow.svg"></a>
            <a href="javascript:void(0);" class="allowBtn" *ngIf="dashboardData?.profileScore < 50"
              routerLink="/profile/edit"> Update Profile <img src="assets/images/arrow.svg"></a>
          </div>

          <div class="lastupdated">
            <p><img src="assets/images/last-update.svg" alt="trophy" class="ht"> Updated: {{lastProfileUpdatedDate |
              date}}</p>
          </div>
        </div>

      </div>

      <div class="col-lg-4 col-sm-12 col-md-12 jobsDetailbox">
        
          <div class="whitebox flexcss">
            <div class="flexcss">
              <img src="assets/images/jobs_applied.svg" class="wt" alt="applied">
              <div class="minheading ">
                <h6>Applied jobs</h6>
                <p class="data">{{dashboardData?.countApplyJob || 0}}</p>
              </div>
            </div>
            <a [routerLink]="'/applied-jobs'" class="orange">See all <img src="assets/images/arrow.svg"></a>
          </div>            
          <div class="whitebox flexcss mt-4">
            <div class="flexcss">
              <img src="assets/images/saved_job.svg" class="wt" alt="applied">
              <div class="minheading ">
                <h6>Saved jobs</h6>
                <p class="data">{{dashboardData?.countSaveJob || 0}}</p>
              </div>
            </div>
            <a [routerLink]="'/saved-jobs'" class="orange">See all <img src="assets/images/arrow.svg"></a>
          </div>       

      </div>
    </div>
  </div>
</section>
<!-- Job roles -->
<section class="pd-tb-2">
  <div class="container">
    <h3 class="subheading flexcss">Job Roles <a href="javascript:void(0)" class="orange flexcss" routerLink="/job-roles"
        [queryParams]="{ type: 'roles'}">See all <img src="assets/images/arrow.svg"></a></h3>
    <div class="mainJob">
      <a class="greyBox" *ngFor="let jobRole of dashboardData.jobRole">
        <h3 routerLink="/seeall" [queryParams]="{ type: 'roles',extras:jobRole.id}">{{jobRole.name}}</h3>
      </a>
    </div>
  </div>
</section>
<!-- End -->

<!-- Latest Jobs -->
<section class="pd-tb-2 pt-0">
  <div class="container">
    <h3 class="subheading flexcss">{{dashboardData.recommandJob ? 'Recommended Jobs For You':'Latest Jobs'}}<a
        href="javascript:void(0)" class="orange flexcss" routerLink="/seeall" [queryParams]="{ type: 'latest'}">See
        all<img src="assets/images/arrow.svg"></a></h3>
    <!-- Row -->
    <div class="row">
      <!-- Job Card -->
      <div *ngFor="let job of dashboardData.recommandJob || dashboardData.latestJobs; let i=index"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
        <app-job-item [job]="job" [routerLink]="'/detail/' + job?.id"
          [queryParams]="{type: 'recommanded',extras:job?.id }" (onJobSaved)="onJobSaved($event)" *ngIf="i<4">
        </app-job-item>
      </div>
      <!--End Job card div  -->
    </div>
    <!-- End -->
  </div>
</section>
<!-- End -->

<!-- Employers of choice-->
<section class=" choice pd-tb-2 pt-0">
  <div class="container">
    <h3 class="subheading flexcss">Employers of choice<a routerLink="/employer-choice" class="orange flexcss">See all
        <img src="assets/images/arrow.svg"></a></h3>
    <div class="mainJob">
      <div class="greyBox pointer" *ngFor="let employer of dashboardData.employersChoice"
        (click)="openEmployerDetails(employer.id)">
        <span class="featured">Featured</span>
        <img src="{{employer.profileImage != null ? recruiterImagePath : ''}}{{employer.profileImage != null ? employer.profileImage : 'assets/images/profile-img.jpg' }}" alt="client">
      </div>
    </div>
  </div>
</section>
<!-- End -->

<!-- Industry jobs-->
<section *ngFor="let industry of dashboardData.industriestList">
  <div *ngIf="industry.listing.length > 0" class="container pd-tb pt-0">
    <h3 class="subheading flexcss">{{industry.title}}<a href="javascript:void(0);" class="orange flexcss"
        routerLink="/seeall" [queryParams]="{ type: 'indus'}">See all <img src="assets/images/arrow.svg"></a></h3>
    <!-- Row -->
    <div class="row">
      <!-- Job Card -->
      <div *ngFor="let job of industry.listing; let i=index" class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
        <app-job-item [job]="job" [routerLink]="'/detail/' + job?.id"
          [queryParams]="{type: 'industry',extras:industry.industryId }" (onJobSaved)="onJobSaved($event)" *ngIf="i<4">
        </app-job-item>
      </div>
      <!--End Job Card div  -->
    </div>
    <!-- End -->
  </div>
</section>
<!-- End -->
</div>